// extracted by mini-css-extract-plugin
module.exports = {"buttonOverride":"_3MCQjl"};